// resources/js/ui/header/header-menu.js
export default function headerMenu(options = {}) {
  const cfg = {
    trigger: options.trigger || '.wk-hamburger',   // het hamburger icoon
    panel: options.panel || '#wk-header-panel',    // het offcanvas menu
    overlay: options.overlay || '#wk-header-overlay',
    closeBtn: options.closeBtn || '.wk-header__close',
    openClass: options.openClass || 'is-open',
    overlayClass: options.overlayClass || 'is-active',
    lockClass: options.lockClass || 'wk-scroll-lock',
  };

  const $trigger = document.querySelector(cfg.trigger);
  const $panel   = document.querySelector(cfg.panel);
  const $overlay = document.querySelector(cfg.overlay);

  if (!$panel || !$overlay || !$trigger) return; // niets te doen

  let lastFocused = null;
  let unbindFocusTrap = null;

  const setAria = (open) => {
    $panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    $trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const lockScroll = (on) => {
    const b = document.body;
    if (on) {
      const hasScrollbar = window.innerWidth > document.documentElement.clientWidth;
      if (hasScrollbar) {
        const pr = window.innerWidth - document.documentElement.clientWidth;
        b.style.paddingRight = pr ? `${pr}px` : '';
      }
      b.classList.add(cfg.lockClass);
      b.style.overflow = 'hidden';
    } else {
      b.classList.remove(cfg.lockClass);
      b.style.overflow = '';
      b.style.paddingRight = '';
    }
  };

  const getFocusable = () => {
    const sel = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');
    return Array.from($panel.querySelectorAll(sel))
      .filter(el => el.offsetParent !== null || el === document.activeElement);
  };

  const trapFocus = () => {
    const nodes = getFocusable();
    if (!nodes.length) return () => {};
    const first = nodes[0];
    const last  = nodes[nodes.length - 1];

    const handler = (e) => {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', handler);
    first.focus();

    return () => document.removeEventListener('keydown', handler);
  };

  const open = () => {
    if ($panel.classList.contains(cfg.openClass)) return;
    lastFocused = document.activeElement instanceof HTMLElement ? document.activeElement : null;

    $panel.classList.add(cfg.openClass);
    $overlay.classList.add(cfg.overlayClass);
    setAria(true);
    lockScroll(true);
    unbindFocusTrap = trapFocus();
  };

  const close = () => {
    if (!$panel.classList.contains(cfg.openClass)) return;
    $panel.classList.remove(cfg.openClass);
    $overlay.classList.remove(cfg.overlayClass);
    setAria(false);
    lockScroll(false);
    if (typeof unbindFocusTrap === 'function') unbindFocusTrap();

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  };

  const toggle = () => ($panel.classList.contains(cfg.openClass) ? close() : open());

  // Core events
  $trigger.addEventListener('click', (e) => { e.preventDefault(); toggle(); });
  $overlay.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  // Close buttons in panel
  $panel.querySelectorAll(cfg.closeBtn).forEach(btn => btn.addEventListener('click', close));

  return { open, close, toggle };
}
